import { render } from "./tablet.vue?vue&type=template&id=4214bb80"
import script from "./tablet.vue?vue&type=script&lang=js"
export * from "./tablet.vue?vue&type=script&lang=js"

import "./tablet.vue?vue&type=style&index=0&id=4214bb80&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__